import React from "react";
import styles from "./Section7.module.scss";

export const Section7 = function () {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <section id="video" className={styles.content}>
        <iframe
          className="embed-responsive-item"
          data-src="https://www.youtube.com/embed/5XjJTbuGz8k"
          allowFullScreen
          src="https://www.youtube.com/embed/5XjJTbuGz8k"
        />
      </section>
    </section>
  );
};
